import { render, staticRenderFns } from "./SetOfCriteriaSave.vue?vue&type=template&id=3c3e115a&"
import script from "./SetOfCriteriaSave.vue?vue&type=script&lang=js&"
export * from "./SetOfCriteriaSave.vue?vue&type=script&lang=js&"
import style0 from "./SetOfCriteriaSave.vue?vue&type=style&index=0&id=3c3e115a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports